import type { Colors } from '../theme';

interface Props {
  children: string;
  colors: Colors;
  mobile: boolean;
}

const ASCII_RULE = "─".repeat(40);

export default function SectionHeading({ children, colors, mobile }: Props) {
  return (
    <>
      <p style={{
        margin: "0 0 10px",
        fontSize: 12,
        letterSpacing: "0.02em",
        color: colors.muted,
        fontFamily: "'0xProto', 'JetBrains Mono', monospace",
        textAlign: mobile ? "center" : undefined,
      }}>
        {children}
        <span style={{
          display: "inline-block",
          width: "0.5em",
          height: "1em",
          background: colors.fg,
          marginLeft: 2,
          verticalAlign: "-0.15em",
          animation: "cursor-blink 1s step-end infinite",
        }} />
      </p>
      <p style={{
        margin: "0 0 38px",
        fontSize: 12,
        letterSpacing: "-1px",
        color: colors.hair,
        fontFamily: "'0xProto', 'JetBrains Mono', monospace",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: mobile ? "center" : undefined,
      }}>
        {ASCII_RULE}
      </p>
    </>
  );
}
